import { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Route, Routes } from 'react-router-dom';

import { AccountService } from '../service/AccountService';
import { TenantSettingService } from './he-thong/tham-so-he-thong/TenantSettingService';

import { AppTopbar } from './AppTopbar';
import { AppBreadCrumb } from './AppBreadCrumb';

import Dashboard from './components/Dashboard';
import Admin from './admin';
import Category from './danh-muc';
import System from './he-thong';
import Invoice from './ban-hang';
import Publish from './phat-hanh';
import LichSuTruyenNhan from './lich-su-truyen-nhan';
import XuLySaiSot from './xu-ly-sai-sot';
import BaoCao from './bao-cao';

import { AppStorage } from '../service/UserStorage';
import { FormatDisplay } from '../shared/format';
import Config from './cau-hinh';
import { ApplicationConfigurationService } from '../service/ApplicationConfigurationService';


export default function App() {

  const [layoutColorMode, setLayoutColorMode] = useState('light');

  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (!AppStorage.get('tenantName')) {
      window.location.hash = '/login';
    } else {
      AccountService.getMyProfile().then((user) => {
        if (user?.userName) {
          setUser(user);
          ApplicationConfigurationService.get().then((res) => {
            let permissions = Object.keys(res.auth.grantedPolicies);
            setPermissions(permissions);
            AppStorage.set('pk', JSON.stringify(permissions));
          });
        } else {
          window.location.hash = '/login';
        }
      }).catch(() => {
        window.location.hash = '/login';
      });
      // });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onColorModeChange = (mode) => {
    setLayoutColorMode(mode)
  }

  const wrapperClass = classNames('layout-wrapper layout-overlay', {
    'layout-theme-light': layoutColorMode === 'light'
  });

  return (
    <div className={wrapperClass}>
      {user &&
        <Fragment>
          <AppTopbar layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} user={user} permissions={permissions} />
          <AppBreadCrumb />

          <div className="layout-main-container">
            <div className="layout-main">
              <Routes>
                <Route path="admin/*" element={<Admin />} />
                <Route path="danh-muc/*" element={<Category />} />

                <Route path="/" element={<Dashboard />} />
                {/* <Route path="admin/*" element={<Admin />} /> */}
                {/* <Route path="danh-muc/*" element={<Category />} /> */}
                <Route path="he-thong/*" element={<System />} />
                {/* <Route path="hoa-don/*" element={<Invoice />} /> */}
                <Route path="ban-hang/*" element={<Invoice />} />

                {/* <Route path="phat-hanh/*" element={<Publish />} /> */}
                {/* <Route path="lich-su-truyen-nhan/*" element={<LichSuTruyenNhan />} /> */}
                {/* <Route path="xu-ly-sai-sot/*" element={<XuLySaiSot />} /> */}
                <Route path="bao-cao/*" element={<BaoCao />} />
                <Route path="phat-hanh/*" element={<Publish />} />
                {/* <Route path="cau-hinh/*" element={<Config />} /> */}
              </Routes>
            </div>
          </div>
        </Fragment>
      }
    </div>
  );
}
